import React from 'react';
import { useLocation } from 'react-router-dom';

import { getStepsWithStatus } from 'utils/helper';

import TrackerSteps from './TrackerSteps';

const Tracker = () => {
  const { pathname } = useLocation();
  const steps = getStepsWithStatus(pathname);

  if (!steps) return null;

  const currentStep = steps.find((step) => step.status === 'current');

  if (!currentStep) return null;

  return (
    <div className="tracker -mt-8 mb-10 sm:mb-0">
      <TrackerSteps steps={steps} />
    </div>
  );
};

export default Tracker;
